<!-- Common header-->
<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<!--DISCOUNT SLIDER-->
<div class="mt-8">
    <app-discount-slider apiPath="bottom"></app-discount-slider>
</div>


<!-- Filters -->
<app-listing-filters (onFilterChange)="onFilterChange($event)"></app-listing-filters>

<!--POPULAR EXPERIENCE-->
<section class="popular-experiences-wrp mt-5 st-listing-pop">
    <div class="container">
        <h4 class="heading-w-border mb-6 ml-40">
            <span *ngIf="merchant" class="mr-05">{{merchant?.name | titlecase }} in </span>
            <span *ngIf="category" class="mr-05">{{category?.category_name | titlecase }} in </span>
            <span>{{city?.name}}</span>
        </h4>

        <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap" *ngIf="responseReceived" width="46%">
            <app-standard-product-card class="standardCard w-46 mlf-2" [data]="product" *ngFor="let product of products"></app-standard-product-card>
        </div>

        <!--Loader-->
        <!-- <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap" *ngIf="!responseReceived">
        <div class="popular-experiences-card bg-gray mb-4 w-46 uk-flex">
            <ngx-skeleton-loader animation="progress" appearance="line">
            </ngx-skeleton-loader>
        </div>
    </div> -->

        <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap" *ngIf="responseReceived && products.length === 0">
            <p>No data available</p>
        </div>

        <div class="pagination showpagination" *ngIf="response?.last_page >1">
            <ul class="uk-pagination uk-flex-center" uk-margin>
                <li class="uk-first-column"><a href="javascript:void(0)" (click)="goToPage(response.current_page - 1)"><span
          uk-pagination-previous></span></a></li>
                <li *ngFor="let i of pages" [ngClass]="{'uk-active' : i == response.current_page}"><a href="javascript:void(0)" (click)="goToPage(i)"><span
          *ngIf="i<10">0</span> {{i}} </a></li>
                <li><a href="javascript:void(0)" (click)="goToPage(response.current_page + 1)"><span uk-pagination-next></span></a>
                </li>
            </ul>
        </div>
        <!--pagination-->
    </div>

</section>

<!--TRENDING--->
<app-trending-products apiPath="category" [forceCategory]="pCatagory"></app-trending-products>

<app-footer></app-footer>
